import httpUtils from '../../utils/HttpUtils'

class FavoriteService {

  //收藏项目列表
  async list (type = '',pageNo = '1') {
    var result = null;
    try {
      result = await httpUtils.post('/customer/favorite/list',{type,pageNo});
    } catch (e) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'}
    }
    return result
  }

  //收藏项目（1、商品 2、店铺 3、文章），再次调用接口取消收藏
  async addFavorite (itemId,type) {
    var result = null;
    try {
      result = await httpUtils.post('/customer/favorite/add',{itemId:itemId,type:type});
    } catch (e) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'}
    }
    return result
  }

  //取消收藏项目（1、商品 2、店铺 3、文章）
  async removeFavorite (itemId,type) {
    var result = null;
    try {
      result = await httpUtils.post('/customer/favorite/remove',{itemId:itemId,type:type});
    } catch (e) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'}
    }
    return result
  }

  //是否收藏项目（1、商品 2、店铺 3、文章）
  async favoriteCheck (itemId,type) {
    var result = null;
    try {
      result = await httpUtils.post('/customer/favorite/check',{itemId:itemId,type:type});
    } catch (e) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'}
    }
    return result
  }
}
export default new FavoriteService()
